// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"201":"9f7805074228c0d4","1424":"4e808d895c7bb6c6","3127":"971f3c03d3ed9171","6137":"4d020f46703eef7e","7769":"2d48a84253ae74a0"}[chunkId] + ".css";
};